import { createContext, useState, useContext, SetStateAction } from 'react';

const ScanContext = createContext({
  clearOriginalImage: () => {},
  originalImage: null,
  text: '',
  saveOriginalImage: (image: any) => {},
  setScannedText: (text: string) => {},
});

export function useScan() {
  return useContext(ScanContext);
}

export function ScanProvider({ children }: any) {
  const [originalImage, setOriginalImage] = useState(null);
  const [text, setText] = useState<any>(null);

  const clearOriginalImage = () => {
    setOriginalImage(null);
  };

  const saveOriginalImage = (image: any) => {
    setOriginalImage(image);
  };

  const setScannedText = (text: string) => {
    setText(text);
  };

  return (
    <ScanContext.Provider value={{ clearOriginalImage, saveOriginalImage, originalImage, setScannedText, text }}>
      {children}
    </ScanContext.Provider>
  );
}
